import { render, staticRenderFns } from "./CompanyData.vue?vue&type=template&id=1f28e2be"
import script from "./CompanyData.vue?vue&type=script&lang=js"
export * from "./CompanyData.vue?vue&type=script&lang=js"
import style0 from "./CompanyData.vue?vue&type=style&index=0&id=1f28e2be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports